/** pbHealth: the playback strip above the Players list. English + Arabic (draft). */
const en = {
  "details": "Show the problem | Show {n} problems",
  "title": "Playback",
  "allGood": "No content problems on your online player | No content problems on your {n} online players",
  "noneOnline": "None of your players is online, so playback can't be checked right now",
  "affected": "{n} of {total} players can't play some of their content | {n} of {total} players can't play some of their content",
  "someProblems": "Some content can't play",
  "onPlayers": "on {n} player | on {n} players",
  "everyPlayer": "on every player using it",
  "c_PLAYER_CANT_DOWNLOAD": "{n} player can't download new content | {n} players can't download new content",
  "c_PLAYER_CONTENT_REJECTED": "{n} player rejected new content | {n} players rejected new content",
  "c_PLAYER_FILES_FAILED": "{n} player has content files that failed | {n} players have content files that failed",
  "c_PLAYER_FALLBACK": "{n} player is showing fallback content | {n} players are showing fallback content",
  "c_CONTENT_BROKEN": "Content won't play",
  "c_MEDIA_FILE_MISSING": "A file is missing",
  "fix": "Fix",
  "view": "View",
  "which": "Which players",
  "hide": "Hide",
  "more": "and {n} more",
  "showAll": "Show all {n} problems",
  "fewer": "Show fewer",
  "healthCheck": "Open Health Check"
};
const ar: typeof en = {
  "details": "عرض المشكلة | عرض {n} مشكلات",
  "title": "التشغيل",
  "allGood": "لا مشاكل في المحتوى على المشغّل المتصل | لا مشاكل في المحتوى على مشغلاتك المتصلة ({n})",
  "noneOnline": "لا يوجد مشغّل متصل الآن، لذا لا يمكن فحص التشغيل",
  "affected": "{n} من {total} مشغلات لا تستطيع تشغيل بعض محتواها | {n} من {total} مشغلات لا تستطيع تشغيل بعض محتواها",
  "someProblems": "بعض المحتوى لا يمكن تشغيله",
  "onPlayers": "على مشغّل واحد | على {n} مشغلات",
  "everyPlayer": "على كل مشغّل يستخدمه",
  "c_PLAYER_CANT_DOWNLOAD": "مشغّل واحد لا يستطيع تنزيل المحتوى الجديد | {n} مشغلات لا تستطيع تنزيل المحتوى الجديد",
  "c_PLAYER_CONTENT_REJECTED": "مشغّل واحد رفض المحتوى الجديد | {n} مشغلات رفضت المحتوى الجديد",
  "c_PLAYER_FILES_FAILED": "مشغّل واحد لديه ملفات محتوى فشلت | {n} مشغلات لديها ملفات محتوى فشلت",
  "c_PLAYER_FALLBACK": "مشغّل واحد يعرض المحتوى الاحتياطي | {n} مشغلات تعرض المحتوى الاحتياطي",
  "c_CONTENT_BROKEN": "محتوى لا يعمل",
  "c_MEDIA_FILE_MISSING": "ملف مفقود",
  "fix": "إصلاح",
  "view": "عرض",
  "which": "أي المشغلات",
  "hide": "إخفاء",
  "more": "و{n} غيرها",
  "showAll": "عرض جميع المشاكل ({n})",
  "fewer": "عرض أقل",
  "healthCheck": "فتح فحص الحالة"
};
export default { en, ar };
